/**
 * ThemeToggle component - Button to switch between light and dark themes
 * Shows sun emoji for dark mode and moon emoji for light mode
 */
import React from 'react';
import { useTheme } from '../../../shared/context/ThemeContext';
import * as styles from './themeToggle.css';

export const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className={styles.toggleButton}
      aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
      title={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {/* Show sun emoji when dark mode is active (to switch to light),
          moon emoji when light mode is active (to switch to dark) */}
      {theme === 'dark' ? '☀️' : '🌙'}
    </button>
  );
};

export default ThemeToggle;
